<template>
    <div> 
    <div class="breadcrumbs-container">
        <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
            <ul>
                <li>
                  <router-link :to="{name: 'Home'}">  
                    Home
                  </router-link>
                </li>
                <li class="is-active">
                  <router-link  :to="{name: 'Kitchen', params: {id: user.user_id}}">  
                    {{user.kitchen_name}}'s Kitchen
                  </router-link>                        
                </li>
            </ul>
        </nav>
    </div>  
    
    <section>
    <div class="container"> 
        <article class="media">
            <figure class="media-left">
                <div 
                class="recipe-avatar image"
                v-if="user.image" 
                :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+user.image+'?alt=media)' }">
                </div>
            </figure>
            <div class="media-content">
                <div class="content">
                <p>
                    <strong class="is-size-4">{{user.kitchen_name}}</strong>
                    <span v-if="user.website"> | <a class="is-size-5" :href="'//'+user.website"><small>{{user.website}}</small></a></span>
                <br />
                    {{user.description}}
                </p>
                </div>
                <nav class="level is-mobile">
                <div class="level-left">
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-reply"></i></span>
                    </a>
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-retweet"></i></span>
                    </a>
                    <a class="level-item">
                    <span class="icon is-small"><i class="fas fa-heart"></i></span>
                    </a>
                </div>
                </nav>
            </div>
        </article>
        <b-tabs v-model="activeTab" size="is-large" position="">
            <b-tab-item label="Your Recipes">
                <div class="columns is-multiline">    
                <div class="column is-one-quarter" v-for="recipe in onlyPublished" :key="recipe.id">    
                    <div class="recipe-card card">    
                        <div class="card-image">    
                            <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">    
                                <div v-if="recipe.mainImage" v-bind:style="{
                                  'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + recipe.mainImage[0] + '?alt=media)',    
                                  'background-repeat': 'no-repeat',    
                                  'background-position': 'center',    
                                  'background-size': 'cover',    
                                  'height': '150px'          
                                  }">            
                                </div>            
                            </router-link>    
                        </div>    
                        <div class="card-content">    
                            <div class="media">    
                                <figure class="media-left">
                                    <div 
                                    class="kitchen-avatar"
                                    v-if="user.image" 
                                    :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+user.image+'?alt=media)' }">
                                    </div>
                                </figure>   
                                <div class="media-content">                                    
                                    <p class="has-text-weight-bold">
                                    <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">
                                    {{recipe.name}}
                                    </router-link> 
                                    </p>                                  
                                    <p class="">Made by <strong>{{recipe.kitchen_name}}</strong></p>    
                                </div>    
                            </div>    
                            <div class="content">    
                                <div v-if="recipe.subtitle<80">{{ recipe.subtitle }}</div>
                                <div v-else>{{ recipe.subtitle.substring(0,80)+"..." }}</div>  
                                <span v-for="tag in recipe.tags" :key="tag.id">
                                    <router-link :to="{name: 'tagged', params: {id: tag}}">
                                    <b-tag type="is-dark">#{{tag}}</b-tag>&nbsp;    
                                    </router-link>
                                    </span><br />    
                                <time datetime="2016-1-1">{{ recipe.created_at.toDate() | moment("from", "now") }}</time>    
                            </div>    
                        </div>                            
                    </div>    
                </div>    
            </div>  
            </b-tab-item>

            <b-tab-item label="Liked Recipes">
                <div class="columns is-multiline">    
                    <div class="column is-one-quarter" v-for="recipe in likedRecipes" :key="recipe.id">    
                        <div class="recipe-card card">    
                            <div class="card-image">    
                                <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">    
                                    <div v-if="recipe.mainImage" v-bind:style="{
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + recipe.mainImage[0] + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }">            
                                    </div>            
                                </router-link>    
                            </div>    
                            <div class="card-content">    
                                <div class="media">    
                                    <div class="media-left">    
                                        <figure class="image is-48x48">    
                                            <img src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + +user.image+'?alt=media'">
                                        </figure>    
                                    </div>    
                                    <div class="media-content">                                    
                                        <p class="has-text-weight-bold">
                                        <router-link :to="{name: 'recipe', params: {id: recipe.id, slug: recipe.slug}}">
                                        {{recipe.name}}
                                        </router-link> 
                                        </p>                                  
                                        <p class="">Made by <strong>{{recipe.kitchen_name}}</strong></p>    
                                    </div>    
                                </div>    
                                <div class="content">    
                                    <div v-if="recipe.subtitle<80">{{ recipe.subtitle }}</div>
                                    <div v-else>{{ recipe.subtitle.substring(0,80)+"..." }}</div>   
                                    <span v-for="tag in recipe.tags" :key="tag.id">
                                    <router-link :to="{name: 'tagged', params: {id: tag}}">
                                    <b-tag type="is-dark">#{{tag}}</b-tag>&nbsp;    
                                    </router-link>
                                    </span><br />  
                                    <time datetime="2016-1-1">{{ recipe.created_at.toDate() | moment("from", "now") }}</time>    
                                </div>    
                            </div>    
                        </div>    
                    </div>    
                </div> 
            </b-tab-item>

            <b-tab-item label="Meals">
                <div class="columns is-multiline">    
                    <div class="column is-one-quarter" v-for="meal in meals" :key="meal.id">    
                        <div class="recipe-card card">    
                            <div class="card-image">    
                                <router-link :to="{name: 'meal', params: {id: meal.id, slug: meal.slug}}">    
                                    <div v-if="meal.mainImage" v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + meal.mainImage + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }">            
                                    </div>    
                                    <div v-else v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + meal.recipes[0].mainImage[0] + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }"> 
                                    </div>        
                                </router-link>    
                            </div>    
                            <div class="card-content">    
                                <div class="media">    
                                    <div class="media-left">    
                                        <figure class="image is-48x48">    
                                            <img src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + +user.image+'?alt=media'">
                                        </figure>    
                                    </div>    
                                    <div class="media-content">                                    
                                        <p class="has-text-weight-bold">
                                        <router-link :to="{name: 'meal', params: {id: meal.id, slug: meal.slug}}">
                                        {{meal.name}}
                                        </router-link> 
                                        </p>                                  
                                        <p class="">Made by <strong>{{meal.kitchen_name}}</strong></p>    
                                    </div>    
                                </div>    
                                <div class="content">    
                                    <div v-if="meal.subtitle<80">{{ meal.subtitle }}</div>
                                    <div v-else>{{ meal.subtitle.substring(0,80)+"..." }}</div>
                                    <b-taglist>    
                                        <b-tag type="is-dark" v-for="tag in meal.tags" :key="tag.id">#{{tag}}</b-tag>    
                                    </b-taglist>    
                                    <time datetime="2016-1-1">{{ meal.created_at.toDate() | moment("from", "now") }}</time>    
                                </div>    
                            </div>    
                        </div>      
                    </div>    
                </div>  
            </b-tab-item>

            <b-tab-item label="Menus">
                <div class="columns is-multiline">    
                    <div class="column is-one-quarter" v-for="menu in menus" :key="menu.id">    
                        <div class="recipe-card card">    
                            <div class="card-image">    
                                <router-link :to="{name: 'menu', params: {id: menu.id, slug: menu.slug}}">    
                                    <div v-if="menu.mainImage" v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + menu.mainImage + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }">            
                                    </div>    
                                    <div v-else v-bind:style="{     
                                    'background-image': 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + menu.menu[0].recipes[0].mainImage + '?alt=media)',    
                                    'background-repeat': 'no-repeat',    
                                    'background-position': 'center',    
                                    'background-size': 'cover',    
                                    'height': '150px'          
                                    }"> 
                                    </div>        
                                </router-link>    
                            </div>    
                            <div class="card-content">    
                                <div class="media">    
                                    <div class="media-left">    
                                        <figure class="image is-48x48">    
                                            <img src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + +user.image+'?alt=media'">
                                        </figure>    
                                    </div>    
                                    <div class="media-content">                                    
                                        <p class="has-text-weight-bold">
                                        <router-link :to="{name: 'menu', params: {id: menu.id, slug: menu.slug}}">
                                        {{menu.name}}
                                        </router-link> 
                                        </p>                                  
                                        <p class="">Made by <strong>{{menu.kitchen_name}}</strong></p>    
                                    </div>    
                                </div>    
                                <div class="content">    
                                    <div v-if="menu.subtitle<80">{{ menu.subtitle }}</div>
                                    <div v-else>{{ menu.subtitle.substring(0,80)+"..." }}</div> 
                                    <b-taglist>    
                                        <b-tag type="is-dark" v-for="tag in menu.tags" :key="tag.id">#{{tag}}</b-tag>    
                                    </b-taglist>    
                                    <time datetime="2016-1-1">{{ menu.created_at.toDate() | moment("from", "now") }}</time>    
                                </div>    
                            </div>                               
                        </div>      
                    </div>    
                </div> 
            </b-tab-item>
        </b-tabs>
    </div>
    </section>       
    </div>
</template>

<script>
import db from '@/db';
export default {
     data() {
        return {
            id: this.$route.params.id,
            recipes: [],
            likedRecipes: [],
            meals: [],
            menus: [],
            activeTab: 0,
            user:Object
        }
    },
    async mounted() {
        await this.fetchData()
    },
    watch: {
        "$route": "fetchData"
    },
    computed: {
        onlyPublished: function () {
            return this.recipes.filter(function (recipe) {
                return recipe.status == 'published'
            })
        }
    },
    methods: {
        fetchData() {
        db.collection('recipes').where('user_id', '==', this.id).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.recipes.push(doc.data());
            })            
        }); 

        db.collection('users').doc(this.id)
            .get().then(docSnapshot => {
                if (!docSnapshot.exists) return this.$router.push({ name: 'Home'});
                this.user = docSnapshot.data();
        });

        db.collection('meals').where('user_id', '==', this.id).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.meals.push(doc.data());
            })            
        }); 

        
        db.collection('menus').where('user_id', '==', this.id).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.menus.push(doc.data());
            })            
        });

        db.collection('recipeLikeables').where('user_id', '==', this.id).get().then((querySnapshot) => {                    
            querySnapshot.forEach((doc) => {
                var likeRecipeRef = db.collection('recipes').doc(doc.data().recipe_id);
                likeRecipeRef.get().then(snapshot => {
                    if (!snapshot.exists) return;
                    this.likedRecipes.push(snapshot.data())  // 
                    console.log(this.recipes)
                });
            })
        });
         
        }
    }
};
</script>